export const PHOTO_GALLERY_CONFIG = {
  defaultQuality: 90, // 0-100
} as const;
